import type { FC } from 'react'

import { Button, ButtonStatus, ButtonType } from '@sok/design-system'
import styled from 'styled-components'

interface ContainerProps {
  color?: string
  textColor?: string
}

interface NotificationProps {
  color?: string
  text?: string
  textColor?: string
  button?: boolean
  buttonText?: string
  actionHandler?: () => void
  icon?: JSX.Element
}

export const Notification: FC<NotificationProps> = ({
  text,
  color,
  textColor,
  button,
  buttonText,
  actionHandler,
  icon,
}) => (
  <StyledContainer color={color} textColor={textColor}>
    <span>
      {icon && <i role="presentation">{icon}</i>}
      {text}
    </span>
    {button && (
      <Button
        status={ButtonStatus.WARNING}
        type={ButtonType.LINK}
        onClick={actionHandler}
        size="small"
        text={buttonText}
      />
    )}
  </StyledContainer>
)

const StyledContainer = styled.div<ContainerProps>(
  {
    display: 'flex',
    flexDirection: 'column',
  },
  ({ color }) => ({ backgroundColor: color }),
  ({ textColor }) => ({ color: textColor }),
  ({ theme }) => ({
    ...theme.variants.body1.regular,
    padding: theme.spacings.medium,
    marginTop: theme.spacings.xxxSmall,
    '> button': {
      justifySelf: 'flex-start',
      width: 'fit-content',
      marginTop: theme.spacings.xxSmall,
    },
    '> span': {
      display: 'flex',

      '> i': {
        marginRight: theme.spacings.xSmall,
      },
    },
  }),
)
